module.exports = __webpack_public_path__ + "static/media/features-interactive-full.1677c54b.png";